var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body terms-conditions",domProps:{"innerHTML":_vm._s(_vm.Terms)}})
}
var staticRenderFns = []

export { render, staticRenderFns }